import { type LandingPageMembershipTabData } from '@/app/components/LandingPage/LandingPageMembershipTabs/LandingPageMembershipTabContent/LandingPageMembershipTabContentCard';

type JapaneseLandingPageMembershipTabPanelOverrides = Partial<
  LandingPageMembershipTabData['tabPanel']
>;
type JapaneseLandingPageMembershipTabDataOverrides = Record<
  string,
  { tabPanel: JapaneseLandingPageMembershipTabPanelOverrides }
>;

// Override the featured images for the Japanese regional site
const japaneseMembershipTabsOverrides: JapaneseLandingPageMembershipTabDataOverrides =
  {
    sleep: {
      tabPanel: {
        featuredImage: {
          backgroundImage: {
            src: 'ja-regional/membership-sleep.jpg',
            localizedAlt: 'explore_image_alt_1',
          },
        },
      },
    },
    activity_and_fitness: {
      tabPanel: {
        featuredImage: {
          backgroundImage: {
            src: 'ja-regional/membership-activity-and-fitness.jpg',
            localizedAlt: 'woman_jogging_img_alt',
          },
        },
      },
    },
    readiness: {
      tabPanel: {
        featuredImage: {
          backgroundImage: {
            src: 'ja-regional/membership-readiness.jpg',
            localizedAlt: 'man_taking_photo_img_alt',
          },
        },
      },
    },
    stress: {
      tabPanel: {
        featuredImage: {
          backgroundImage: {
            src: 'ja-regional/membership-stress.jpg',
            localizedAlt: 'man_cup_img_alt',
          },
        },
      },
    },
    womens_health: {
      tabPanel: {
        featuredImage: {
          backgroundImage: {
            src: 'ja-regional/membership-womens-health.jpg',
            localizedAlt: 'woman_yoga_img_alt',
          },
        },
      },
    },
  };

export default japaneseMembershipTabsOverrides;
